//  @/store/modules/authentication.js

import  * as firebase from "firebase/app"
import 'firebase/auth'
import 'firebase/functions'
import 'babel-polyfill'

const state = {
  user: null,
  users: [],
  headers: [
    {
      text: 'Nom complet',
      value: 'displayName',
    },
    {
      text: 'Courriel',
      value: 'email',
    },
    {
      text: 'Rôles',
      value: 'customClaims',
    },
  ],
}

const mutations = {
  SET_USER (state, user) {
    state.user = user
  },
  SET_USERS (state, users) {
    state.users = users
  },
  UNSET_USER (state) {
    state.user = null
  }
}

const getters = {
  validUser: state => { return Boolean(state.user) },
  isAdmin: state => { return Boolean(state.user) && Boolean(state.user.admin) },
}

const actions = {
  init({commit, dispatch}) {
    firebase.auth().useDeviceLanguage()
    firebase.auth().provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
        user.getIdTokenResult().then(idTokenResult => {
          if(user.email.split('@')[1].toLowerCase() !== 'lacartoucherie.com') {
            console.warn(`Utilisateur non autorisé.`)
            firebase.auth().signOut()
            if(Boolean(state.user)) commit('UNSET_USER')
          }
          else {
            if(Boolean(idTokenResult.claims.admin)) {
              dispatch('listAllUsers')
            }
            commit('SET_USER', {id: user.uid, ...idTokenResult.claims, ...user.providerData[0]})
          }
        })
      } else {
        if(Boolean(state.user)) {
          firebase.auth().signOut()
          commit('UNSET_USER')
        }
      }
    })
  },
  async listAllUsers({commit}) {
    let listUsers = firebase.functions().httpsCallable('listAllUsers')
    let users = await listUsers()
    commit('SET_USERS', users.data.users)
  },
  signIn({commit}) {
    firebase.auth().signInWithPopup(firebase.auth().provider)
    .catch(error => {
      console.log(error.message)
      commit('UNSET_USER')
    })
  },
  signOut({commit, dispatch}) {
    dispatch('close', null, { root: true })
    firebase.auth().signOut()    
    commit('UNSET_USER')
  },
}

export default { 
  namespaced: true, state, mutations, getters, actions
}